import { Injectable } from '@angular/core';
import { AnimationDurations, CanColor } from '@angular/material';
import { configuration } from 'src/environments/environment';
import { Defaults } from '../Utilities/defaults';
import { DocumentService } from './Documents/document.service';
/*import { homedir } from 'os';*/
export class Menu {
    menuId: number;
    menutext: string;
    icon: string;
    icon2?: string;
    submenus: SubMenu[];
}

export class SubMenu {
    submenuid: number;
    submenutext?: string;
    icon: string;
    routelink?: string;
}
let menulist: Menu[] = []
// let menulist: Menu[] = [
//     {
//         menuId: 1,
//         menutext: "Home",
//         icon: "assets/images/menu1/home.png",
//         icon2: "assets/images/menu1/home.png",
//         submenus: [{ submenuid: 1, submenutext: "Dashboard", icon: "", routelink: "/providerdashboard" },
//         { submenuid: 2, submenutext: "New Patient", icon: "", routelink: "/Demographics" }]
//     },
//     {
//         menuId: 9,
//         menutext: "Home",
//         icon: "assets/images/menu1/home.png",
//         icon2: "assets/images/menu1/home.png",
//         submenus: [{ submenuid: 1, submenutext: "Dashboard", icon: "", routelink: "/nursedashboard" },
//         { submenuid: 2, submenutext: "New Patient", icon: "", routelink: "/Demographics" }]
//     },
//     {
//         menuId: 10,
//         menutext: "Home",
//         icon: "assets/images/menu1/home.png",
//         icon2: "assets/images/menu1/home.png",
//         submenus: [{ submenuid: 1, submenutext: "Dashboard", icon: "", routelink: "/clerkdashboard" },
//         { submenuid: 2, submenutext: "New Patient", icon: "", routelink: "/Demographics" }]
//     },
//     {
//         menuId: 11,
//         menutext: "Home",
//         icon: "assets/images/menu1/home.png",
//         icon2: "assets/images/menu1/home.png",
//         submenus: [{ submenuid: 1, submenutext: "Dashboard", icon: "", routelink: "/homeorders" },
//         { submenuid: 2, submenutext: "New Patient", icon: "", routelink: "/Demographics" }]
//     },
//     {
//         menuId: 2,
//         menutext: "Calendar",
//         icon: "assets/images/menu1/calendar.png",
//         icon2: "assets/images/menu1/calendar.png",

//         submenus: [{ submenuid: 1, submenutext: "Patient Board", icon: "", routelink: "/Appointments" }
//             , { submenuid: 2, submenutext: "New App", icon: "", routelink: "/NewAppointment" },
//         { submenuid: 3, submenutext: "Check In", icon: "", routelink: "/CheckIn"}
//             , { submenuid: 4, submenutext: "Check Out", icon: "" },
//         { submenuid: 5, submenutext: "Providers", icon: "" }
//             , { submenuid: 6, submenutext: "Settings", icon: "" },
//         { submenuid: 7, submenutext: "CheckedIn", icon: "", routelink: "/CheckedIn" },]
//     },
//     {
//         menuId: 3,
//         menutext: "Patient Chart",
//         icon: "assets/images/menu1/patient.png",
//         icon2: "assets/images/menu1/patient.png",
//         submenus: [
//             { submenuid: 3, submenutext: "Summary", icon: "", routelink: "/Demographics" }
//             , { submenuid: 3, submenutext: "Demographics", icon: "", routelink: "/Demographics" }
//             , { submenuid: 3, submenutext: "Docs", icon: "", routelink: "/DocumentHome" }
//             , { submenuid: 3, submenutext: "Past Notes", icon: "", routelink: "/Pastnotes" }
//             , { submenuid: 3, submenutext: "New Visit Note", icon: "", routelink: "/Visitnote" }
//             , { submenuid: 3, submenutext: "New OR Note", icon: "", routelink: "/ORNote" }
//             , { submenuid: 3, submenutext: "Hx", icon: "" }
//             , { submenuid: 3, submenutext: "Rx", icon: "" },
//             // { submenuid: 4, submenutext: "Refill Request", icon: "", routelink: "/RefillRequest" }
//         ]

//     },
//     {
//         menuId: 4,
//         menutext: "Messages",
//         icon: "assets/images/menu1/message.png",
//         icon2: "assets/images/menu1/message.png",
//         submenus: [{ submenuid: 1, submenutext: "Inbox", icon: "", routelink: '/message' }
//             , { submenuid: 2, submenutext: "New Message", icon: "", routelink: '' },
//         { submenuid: 3, submenutext: "Send Message", icon: "" },
//         { submenuid: 4, submenutext: "Forward Message", icon: "" },
//         { submenuid: 5, submenutext: "Reply All", icon: "" },
//         { submenuid: 6, submenutext: "Delete Message", icon: "" },
//         { submenuid: 7, submenutext: "Cancel", icon: "" },
//             // { submenuid: 8, submenutext: "Send/Receive", icon: "" },
//         ]
//     },
//     {
//         menuId: 5,
//         menutext: "Reports",
//         icon: "assets/images/menu1/report.png",
//         icon2: "assets/images/menu1/report.png",
//         submenus: [{ submenuid: 1, submenutext: "Patient", icon: "" },
//         { submenuid: 2, submenutext: "Audit", icon: "", },
//         { submenuid: 3, submenutext: "Scheduling", icon: "" },
//         { submenuid: 4, submenutext: "Clinical", icon: "" },
//         { submenuid: 5, submenutext: "Orders", icon: "" },
//         { submenuid: 6, submenutext: "Clinical Quality", icon: "" },
//         { submenuid: 7, submenutext: "General", icon: "" },
//         { submenuid: 8, submenutext: "System", icon: "" },]
//     },
//     {
//         menuId: 6,
//         menutext: "Templates",
//         icon: "assets/images/menu1/template.png",
//         icon2: "assets/images/menu1/template.png",
//         submenus: [{ submenuid: 1, submenutext: "Macros", icon: "", routelink: "/Template/3/true" },
//         { submenuid: 2, submenutext: "Calendar Templates", icon: "", routelink: "Template/Calendar" },
//         { submenuid: 3, submenutext: "Document Library", icon: "", routelink: "DocumentLibrary" },

//         ]


//     },
//     {
//         menuId: 7,
//         menutext: "MU",
//         icon: "assets/images/menu1/mu.png",
//         icon2: "assets/images/menu1/mu.png",
//         submenus: [{ submenuid: 1, submenutext: "AMC", icon: "" },
//         { submenuid: 2, submenutext: "CQMS", icon: "" },
//         { submenuid: 3, submenutext: "PQRS", icon: "" },
//         { submenuid: 4, submenutext: "HL7", icon: "" },
//         { submenuid: 5, submenutext: "MACRA", icon: "" },
//         ]
//     },
//     {
//         menuId: 8,
//         menutext: 'Admin',
//         icon: 'assets/images/menu1/admin.png',
//         icon2: 'assets/images/menu1/admin.png',
//         submenus: [
//             { submenuid: 1, submenutext: 'Dashboard', icon: '' },
//             // { submenuid: 2, submenutext: 'Import Document', icon: '', routelink: '/Document' },
//             // { submenuid: 3, submenutext: 'View Documents', icon: '', routelink: '/ViewDocuments' },
//             { submenuid: 2, submenutext: 'Permissions', icon: '' },
//             { submenuid: 3, submenutext: 'Roles', icon: '' },
//             { submenuid: 4, submenutext: 'Configure', icon: '', routelink: '/Configure' },
//             { submenuid: 5, submenutext: 'Practice', icon: '' },
//             { submenuid: 6, submenutext: 'Providers', icon: '' },
//             { submenuid: 7, submenutext: 'Locations', icon: '', routelink: '/Locations' },
//             { submenuid: 8, submenutext: 'Scheduler', icon: '', routelink: 'Scheduler' },
//             { submenuid: 9, submenutext: 'Billing', icon: '', routelink: 'Billing' },
//            // { submenuid: 10, submenutext: 'Asc', icon: '', routelink: 'Asc' },
//             { submenuid: 11, submenutext: 'Clinic', icon: '', routelink: 'Clinic' },
//             { submenuid: 12, submenutext: 'New User', icon: '', routelink: '/User' },
//             { submenuid: 13, submenutext: 'Manage Users', icon: '', routelink: '/ManageUser' },
//             { submenuid: 14, submenutext: 'Reset Password', icon: '', routelink: '/ResetPassword' },
//             { submenuid: 15, submenutext: 'Manage eRx', icon: '', routelink: 'ManageErx' },
//             { submenuid: 16, submenutext: 'Active Users', icon: '', routelink: 'ActiveUsers' },
//             { submenuid: 16, submenutext: 'Unlock User', icon: '', routelink: 'unlockuser' },
//             { submenuid: 17, submenutext: 'Track Medication', icon: '', routelink: 'Track' },
//             { submenuid: 18, submenutext: 'CPT Master', icon: '', routelink: 'cptmaster' },
//             { submenuid: 19, submenutext: 'Manage CPT Code', icon: '', routelink: 'ManageCPTcode' },
//             { submenuid: 20, submenutext: 'Role', icon: '', routelink: 'Role' },
//             { submenuid: 21, submenutext: 'Permission', icon: '', routelink: 'Permission' },
//             { submenuid: 22, submenutext: 'EPCS Console', icon: '', routelink: 'EpcsConsole' },
//             { submenuid: 23, submenutext: 'Audit Trail', icon: '', routelink: 'AuditTrail' },
//         ]
//     },
//     {
//         menuId: 9,
//         menutext: "RX",
//         icon: "assets/images/menu1/mu.png",
//         icon2: "assets/images/menu1/mu.png",
//         submenus: [],
//     },
// ];

@Injectable({ providedIn: 'root' })
export class CommonService {
    getMenus(): Menu[] {
        return menulist;
    }
}

export class DProduct {
    ID: number;
    Name: string;
}

let simpleProducts: string[] = [
    "HD Video Player",
    "SuperHD Video Player",
    "SuperPlasma 50",
    "SuperLED 50",
    "SuperLED 42"
];

let products: DProduct[] = [
    {
        "ID": 1,
        "Name": "My Profile"
    }, {
        "ID": 2,
        "Name": "Change Password"
    }, {
        "ID": 3,
        "Name": "View Permissions"
    },
    {
        "ID": 4,
        "Name": "Enable Emergency Access"
    }
    , {
        "ID": 5,
        "Name": "Settings"
    }, {
        "ID": 6,
        "Name": "Logout"

    }];


@Injectable({ providedIn: 'root' })
export class DService {
    getSimpleProducts(): string[] {
        return simpleProducts;
    }
    getProducts(): DProduct[] {
        return products;
    }
}

export class OuterMenu {
    id?: string;
    name?: string;
    icon?: string;
    icon2?: string;
    price?: number;
    items?: OuterMenu[];
    show?: boolean;
    routelink?: string;
    activemenu?: boolean;
}


let outerMainMenuList: OuterMenu[] =
    []

// This menu has been old menu before modified 19-AUG-2020
// var outermenulist: OuterMenu[] =
//     [
//         {
//             id: "1",
//             name: "Home",
//             icon: "assets/images/menu1/home.svg",
//             icon2: "assets/images/menu1/home.svg",
//             show: true,
//             activemenu: false,
//             items: [{
//                 id: "1_1",
//                 name: "Dashboard",
//                 show: false,
//                 price: 220,activemenu: false,
//                 routelink: "/providerdashboard"
//             },
//             {
//                 id: "1_3",
//                 name: "Nurse Dashboard",
//                 show: false,
//                 price: 220,activemenu: false,
//                 routelink: "/nursedashboard"
//             },
//             {
//                 id: "1_4",
//                 name: "Clerk Dashboard",
//                 show: false,
//                 price: 220,activemenu: false,
//                 routelink: "/clerkdashboard"
//             },
//             {
//                 id: "1_5",
//                 name: "Orders",
//                 show: false,
//                 price: 220,activemenu: false,
//                 routelink: "/homeorders"
//             },
//             {
//                 id: "1_2",
//                 name: "New Patient",
//                 show: false,
//                 price: 220,activemenu: false,
//                 routelink: "/Demographics"
//             },
//            ]
//         },
//         {
//             id: "2",
//             name: "Calendar",
//             icon: "assets/images/menu1/calendar.svg",
//             icon2: "assets/images/menu1/calendar.svg",
//             show: true,
//             activemenu: false,
//             items: [{
//                 id: "2_1",
//                 name: "Patient Board",
//                 icon: "",
//                 show: false,
//                 price: 1200,activemenu: false,
//                 routelink: "/Appointments"
//             },
//             {
//                 id: "2_2",
//                 name: "New Appointment",
//                 icon: "",
//                 price: 1450,activemenu: false,
//                 routelink: "/NewAppointment"
//             },
//             {
//                 id: "2_3",
//                 name: "Check In",
//                 icon: "",activemenu: false,
//                 // routelink: "/CheckedIn",
//                 price: 1600
//             },
//             {
//                 id: "2_4",
//                 name: "Check Out",
//                 icon: "",activemenu: false,
//                 price: 1350,
//             },
//             {
//                 id: "2_5",
//                 name: "Providers",
//                 icon: "",activemenu: false,
//                 price: 4000
//             },
//             {
//                 id: "2_6",
//                 name: "Settings",
//                 icon: "",activemenu: false,
//                 price: 4000
//             },
//             {
//                 id: "2_7",
//                 name: "Provider Calender",
//                 icon: "",activemenu: false,
//                 routelink: "/ProviderCalender"
//             },
//             {
//                 id: "2_8",
//                 name: "Staff Calender",
//                 icon: "",activemenu: false,
//                 routelink: "/StaffCalender"
//             },


//         ]
//         },
//         {
//             id: "3",
//             name: "Patient Chart",
//             show: true,
//             activemenu: false,
//             icon: "assets/images/menu1/patient.svg",
//             icon2: "assets/images/menu1/patient.svg",
//             items: [{
//                 id: "3_1",
//                 name: "Summary",
//                 icon: "",
//                 show: false,
//                 price: 270,activemenu: false,
//                 routelink: "/Demographics"
//             },
//             {
//                 id: "3_2",
//                 name: "Demographics",
//                 icon: "",
//                 show: false,
//                 price: 270,activemenu: false,
//                 routelink: "/Demographics"
//             },
//             {
//                 id: "3_3",
//                 name: "Documents",
//                 icon: "",
//                 show: false,
//                 price: 270,activemenu: false,
//                 routelink: "/DocumentHome"
//             },
//             {
//                 id: "3_4",
//                 name: "Past Notes",
//                 icon: "",
//                 show: false,
//                 price: 270,activemenu: false,
//                 routelink: "/Pastnotes"
//             },
//             {
//                 id: "3_5",
//                 name: "Hx",
//                 icon: "",
//                 show: false,activemenu: false,
//                 price: 270
//             },
//             {
//                 id: "3_6",
//                 name: "Rx",
//                 icon: "",
//                 show: false,activemenu: false,
//                 price: 270
//             }
//             // ,
//             // {
//             //     id: "3_7",
//             //     name: "Refill Request",
//             //     icon: "",
//             //     show: false,
//             //     price: 270,
//             //     routelink: "/RefillRequest"
//             // }
//         ]
//         },
//         {
//             id: "4",
//             name: "Messages",
//             icon: "assets/images/menu1/message.svg",
//             icon2: "assets/images/menu1/message.svg",
//             show: true,
//             activemenu: false,
//             items: [{
//                 id: "4_1",
//                 name: "Inbox",
//                 icon: "",activemenu: false,
//                 routelink: '/message'
//             },
//             {
//                 id: "4_2",
//                 name: "New",
//                 icon: "",activemenu: false,
//                 routelink: '/newmessage'
//             },
//             {
//                 id: "4_3",
//                 name: "Send",
//                 icon: "",activemenu: false,
//                 price: 750
//             },
//             {
//                 id: "4_4",
//                 name: "Forward",
//                 icon: "",activemenu: false,
//                 price: 750
//             },
//             {
//                 id: "4_5",
//                 name: "Reply All",
//                 icon: "",activemenu: false,
//                 price: 750
//             },
//             {
//                 id: "4_6",
//                 name: "Delete",
//                 icon: "",activemenu: false,
//                 price: 750
//             },
//             {
//                 id: "4_7",
//                 name: "Cancel",
//                 icon: "",activemenu: false,
//                 price: 750
//             }],
//             // {
//             //     id: "4_8",
//             //     name: "Send/Receive",
//             //     icon: "",
//             //     price: 750
//             // }
//         },
//         {
//             id: "5",
//             name: "Reports",
//             icon: "assets/images/menu1/report.svg",
//             icon2: "assets/images/menu1/report.svg",
//             show: true,
//             activemenu: false,
//             items: [{
//                 id: "5_1",
//                 name: "Patient",
//                 icon: "",activemenu: false,
//                 price: 550
//             },
//             {
//                 id: "5_2",
//                 name: "Audit",
//                 icon: "",activemenu: false,
//                 price: 550,

//             },
//             {
//                 id: "5_3",
//                 name: "Scheduling",
//                 icon: "",activemenu: false,
//                 price: 550
//             },
//             {
//                 id: "5_4",activemenu: false,
//                 name: "Clinical",
//                 icon: "",
//                 price: 550
//             },
//             {
//                 id: "5_5",activemenu: false,
//                 name: "Orders",
//                 icon: "",
//                 price: 550
//             },
//             {
//                 id: "5_6",
//                 name: "Clinical Quality",
//                 icon: "",activemenu: false,
//                 price: 550
//             },
//             {
//                 id: "5_7",activemenu: false,
//                 name: "General",
//                 icon: "",
//                 price: 550
//             },
//             {
//                 id: "5_8",activemenu: false,
//                 name: "System",
//                 icon: "",
//                 price: 550
//             }]
//         },
//         {
//             id: "6",
//             name: "Templates",
//             icon: "assets/images/menu1/template.svg",
//             icon2: "assets/images/menu1/template.svg",
//             show: true,
//             activemenu: false,
//             items: [{
//                 id: "6_1",
//                 name: "Macros",
//                 icon: "",
//                 price: 550,activemenu: false,
//                 routelink: '/Template/3/true'
//             },
//             {
//                 id: "6_2",
//                 name: "Calendar Templates",
//                 icon: "",
//                 price: 550,activemenu: false,
//                 routelink: '/Template/Calendar'
//             }]
//         },
//         {
//             id: "7",
//             name: "MU",
//             icon: "assets/images/menu1/mu.svg",
//             icon2: "assets/images/menu1/mu.svg",
//             show: true,
//             activemenu: false,
//             items: [{
//                 id: "7_1",
//                 name: "AMC",
//                 icon: "",activemenu: false,
//                 price: 160
//             }, {
//                 id: "7_2",
//                 name: "CQMS",
//                 icon: "",activemenu: false,
//                 price: 160
//             },
//             {
//                 id: "7_3",
//                 name: "PQRS",
//                 icon: "",activemenu: false,
//                 price: 160
//             },
//             {
//                 id: "7_4",
//                 name: "HL7",
//                 icon: "",activemenu: false,
//                 price: 160
//             },
//             {
//                 id: "7_5",
//                 name: "MACRA",
//                 icon: "",activemenu: false,
//                 price: 160
//             }]
//         },
//         {
//             id: '8',
//             name: 'Admin',
//             icon: 'assets/images/menu1/admin.svg',
//             icon2: 'assets/images/menu1/admin.svg',
//             show: true,
//             activemenu: false,
//             items: [{
//                 id: '8_1',
//                 name: 'Dashboard',
//                 icon: '',
//                 price: 160,
//                 activemenu: false,

//             },

//             // {
//             //     id: '8_2',
//             //     name: 'Import Document',
//             //     icon: '',
//             //     price: 160,
//             //     routelink: '/Document'
//             // }, {
//             //     id: '8_3',
//             //     name: 'View Documents',
//             //     icon: '',
//             //     price: 160,
//             //     routelink: '/ViewDocuments'
//             // },
//             // {
//             //     id: '8_4',
//             //     name: 'Users',
//             //     icon: '',
//             //     price: 160
//             // },
//             {
//                 id: '8_2',
//                 name: 'Permissions',
//                 icon: '',
//                 price: 160,
//                 routelink: '/Permission',
//                 activemenu: false,
//             },
//             {
//                 id: '8_3',
//                 name: 'Roles',
//                 icon: '',
//                 price: 160,
//                 routelink: '/Role',
//                 activemenu: false,
//             },
//             {
//                 id: '8_4',
//                 name: 'Configure',
//                 icon: '',
//                 price: 160,
//                 routelink: '/Configure',
//                 activemenu: false,
//             },
//             {
//                 id: '8_5',
//                 name: 'Practice',
//                 icon: '',
//                 price: 160,
//                 activemenu: false,
//             },
//             {
//                 id: '8_6',
//                 name: 'Providers',
//                 icon: '',
//                 price: 160,
//                 activemenu: false,
//             },
//             {
//                 id: '8_7',
//                 name: 'Locations',
//                 icon: '',
//                 price: 160, activemenu: false,
//                 routelink: '/Locations'
//             },
//             {
//                 id: '8_8',
//                 name: 'Scheduler', activemenu: false,
//                 icon: '',
//                 price: 160,
//                 routelink: '/Scheduler'
//             },

//             {
//                 id: '8_9',
//                 name: 'Billing', activemenu: false,
//                 icon: '',
//                 price: 160,
//                 routelink: '/Billing'
//             },
//             {
//                 id: '8_10',
//                 name: 'Asc', activemenu: false,
//                 icon: '',
//                 price: 160,
//                 routelink: '/Asc'
//             },
//             {
//                 id: '8_11',
//                 name: 'Clinic', activemenu: false,
//                 icon: '',
//                 price: 160,
//                 routelink: '/Clinic'
//             },

//             {
//                 id: '8_12',
//                 name: 'New User', activemenu: false,
//                 icon: '',
//                 price: 550,
//                 routelink: '/User'
//             },
//             {
//                 id: '8_13',
//                 name: 'Manage Users', activemenu: false,
//                 icon: '',
//                 price: 550,
//                 routelink: '/ManageUser'
//             },
//             {
//                 id: '8_14',
//                 name: 'Reset Password', activemenu: false,
//                 icon: '',
//                 price: 550,
//                 routelink: '/ResetPassword'
//             },
//             {
//                 id: '8_15',
//                 name: 'Manage eRx', activemenu: false,
//                 icon: '',
//                 price: 160,
//                 routelink: '/ManageErx'
//             },
//             {
//                 id: '8_16',
//                 name: 'Active Users',
//                 icon: '',
//                 price: 550, activemenu: false,
//                 routelink: '/ActiveUsers'
//             },
//             {
//                 id: '8_17',
//                 name: 'Unlock User',
//                 icon: '',
//                 price: 550, activemenu: false,
//                 routelink: '/unlockuser'
//             },
//             {
//                 id: '8_18',
//                 name: 'Medications',
//                 icon: '',
//                 price: 550, activemenu: false,
//                 routelink: '/Track'
//             },
//             {
//                 id: '8_19',
//                 name: 'CPT Master',
//                 icon: '', activemenu: false,
//                 price: 550,
//                 routelink: '/cptmaster'
//             },
//             {
//                 id: '8_20',
//                 name: 'Manage CPT Code',
//                 icon: '', activemenu: false,
//                 price: 550,
//                 routelink: '/ManageCPTcode'
//             },
//             {
//                 id: '8_21',
//                 name: 'CQMS Configuaration',
//                 icon: '',
//                 price: 550, activemenu: false,
//                 routelink: '/CQMSConfiguration'
//             },
//             {
//                 id: '8_22', activemenu: false,
//                 name: 'CQMS Dashboard',
//                 icon: '',
//                 price: 550,
//                 routelink: '/CqmsDashboard'
//             },

//             {
//                 id: '8_23', activemenu: false,
//                 name: ' CQMS HEALTH MAINTENANCE ',
//                 icon: '',
//                 price: 550,
//                 routelink: '/CqmsHealthMaintenance'
//             },
//             {
//                 id: '8_24', activemenu: false,
//                 name: 'CQMS QUALIFYING CODES',
//                 icon: '',
//                 price: 550,
//                 routelink: '/CqmsQualifyingCodes'
//             },
//             {
//                 id: '8_25', activemenu: false,
//                 name: 'EPCS Console',
//                 icon: '',
//                 price: 550,
//                 routelink: '/EpcsConsole'
//             },
//             {
//                 id: '8_26', activemenu: false,
//                 name: 'Audit Trail',
//                 icon: '',
//                 price: 550,
//                 routelink: '/AuditTrail'
//             },
//             {
//               id: '8_27',
//               name: 'Manage Facilities',
//               icon: '',
//               price: 550,
//               routelink: '/ManageFacilities'
//           },


//             ]
//         },
//         {
//           id: '9',
//           name: 'Scheduler',
//           icon: 'assets/images/menu1/scheduler.svg',
//           icon2: 'assets/images/menu1/scheduler.svg',
//           show: true,
//           activemenu: false,
//           items:[{
//             id: '9_1',
//             name: 'CalTemplate',
//             icon: '',activemenu: false,
//             routelink: '/CalTemplate',
//             price: 160
//           },
//         {
//           id: '9_2',
//             name: 'Assign Template',
//             icon: '',activemenu: false,
//             routelink: '/AssignTemplate',
//             price: 160
//         }]
//       },
//     ];

// end of the menu

@Injectable({ providedIn: 'root' })
export class SubmenuService {
    getProducts(): OuterMenu[] {
        return outerMainMenuList;
    }
}

export class PatientBoardAction {
    menuitemId: number;
    actionName: string;
    routerLink?: string;
    isNewAction: boolean;
    priority: number;
}

export class PatientMedicationAction {
    menuitemId: number;
    actionName: string;
    routerLink?: string;
    isNewAction: boolean;
    priority: number;
}
// let patientBoardActionList: PatientBoardAction[] = [
//     { menuitemId: 1, actionName: "Visit Note", routerLink: "/Visitnote", isNewAction: false },
//     { menuitemId: 2, actionName: "OR Note", routerLink: "/ORNote", isNewAction: false },
//     { menuitemId: 3, actionName: "Order Note", routerLink: "/OrderNote", isNewAction: false },
//     { menuitemId: 4, actionName: "New Visit Note", routerLink: "/Visitnote", isNewAction: false },
//     { menuitemId: 5, actionName: "New OR Note", routerLink: "/ORNote", isNewAction: false },
//     { menuitemId: 6, actionName: "New Order Note", routerLink: "/OrderNote", isNewAction: false }
// ]

let patientBoardActionList: PatientBoardAction[] = [
    { menuitemId: 1, actionName: "New Visit Note", routerLink: "/Visitnote", isNewAction: false, priority: 1 },
    { menuitemId: 2, actionName: "InComplete Visit Note", routerLink: "/Visitnote", isNewAction: false, priority: 2 },
    { menuitemId: 3, actionName: "Completed Visit Note", routerLink: "/Visitnote", isNewAction: false, priority: 3 },
    { menuitemId: 4, actionName: "New OR Note", routerLink: "/ORNotee", isNewAction: false, priority: 4 },
    { menuitemId: 5, actionName: "InComplete OR Note", routerLink: "/ORNote", isNewAction: false, priority: 5 },
    { menuitemId: 6, actionName: "Completed OR Note", routerLink: "/ORNote", isNewAction: false, priority: 6 },
    { menuitemId: 7, actionName: "New Order Note", routerLink: "/OrderNote", isNewAction: false, priority: 7 },
    { menuitemId: 8, actionName: "InComplete Order Note", routerLink: "/OrderNote", isNewAction: false, priority: 8 },
    { menuitemId: 9, actionName: "Completed Order Note", routerLink: "/OrderNote", isNewAction: false, priority: 9 },
    { menuitemId: 10, actionName: "Comments", routerLink: "", isNewAction: false, priority: 10 },
    // { menuitemId: 11, actionName: "Future Appointments", routerLink: "", isNewAction: false, priority: 11 }
    { menuitemId: 11, actionName: "Next Appointment", routerLink: "", isNewAction: false, priority: 11 },
    { menuitemId: 12, actionName: "Status Log", routerLink: "", isNewAction: false, priority: 12 },
    { menuitemId: 13, actionName: "Send TM Details", routerLink: "", isNewAction: false, priority: 13 }

]

@Injectable({ providedIn: 'root' })
export class PatientBoardActionservice {
    getPatientBoardMenus(): PatientBoardAction[] {
        return patientBoardActionList;
    }
}


let patientMedicationList: PatientMedicationAction[] = [
    { menuitemId: 1, actionName: "ePrescribe", routerLink: "/", isNewAction: false, priority: 1 },
    // { menuitemId: 2, actionName: "Refill", routerLink: "/", isNewAction: false, priority: 2 },
    { menuitemId: 3, actionName: "Drug Info", routerLink: "/", isNewAction: false, priority: 3 },
    { menuitemId: 4, actionName: "History", routerLink: "/", isNewAction: false, priority: 4 },
    { menuitemId: 5, actionName: "Print", routerLink: "/", isNewAction: false, priority: 5 },

    { menuitemId: 6, actionName: "Edit", routerLink: "/", isNewAction: false, priority: 6 },
    { menuitemId: 7, actionName: "Delete", routerLink: "/", isNewAction: false, priority: 7 },
    //{ menuitemId: 8, actionName: "Deactive", routerLink: "/", isNewAction: false, priority: 8 },

    { menuitemId: 9, actionName: "Cancel Rx", routerLink: "/", isNewAction: false, priority: 8 },
    { menuitemId: 10, actionName: "Renew", routerLink: "/", isNewAction: false, priority: 9 },
]

@Injectable({ providedIn: 'root' })
export class PatientMedicationActionservice {
    getPatientMedicationMenus(): PatientMedicationAction[] {
        return patientMedicationList;
    }

}

export class AuditMedicationAction {
    menuitemId: number;
    actionName: string;
    routerLink?: string;
    isNewAction: boolean;
    priority: number;
}

let auditMedicationList: AuditMedicationAction[] = [
    { menuitemId: 1, actionName: "View Details", routerLink: "/", isNewAction: false, priority: 1 },
    { menuitemId: 2, actionName: "Cancel Rx", routerLink: "/", isNewAction: false, priority: 2 },
    { menuitemId: 3, actionName: "Audit Logs", routerLink: "/", isNewAction: false, priority: 3 },
]

@Injectable({ providedIn: 'root' })
export class AuditMedicationActionservice {
    getauditMedicationMenus(): AuditMedicationAction[] {
        return auditMedicationList;
    }
}
export enum Component_RoleMasterEnum {
    PersonalInformation = 1,
    EmergencyDetails = 2,
    InsuranceDetails = 3,
    Accounts = 4,
    Employment = 5,
    Pharmacy = 6,
    Authorization = 7,
    Alerts = 8,
    Notes = 9,
    Form = 10,
    Referral = 11,
    ClinicalDataExport = 12,
    GenerateCCDA = 13,
    ImportCCDA = 14
}
@Injectable({ providedIn: 'root' })
export class UserRoleservice {
    constructor(private _documentService: DocumentService) {

    }

    GetComponentRolePermissions() {
        if (configuration.ISONCEnabled == true) {
            const roleid = sessionStorage.getItem("roleid");
            const userid = encodeURIComponent(sessionStorage.getItem("userId")).toString();
            let type = 'user'
            if (sessionStorage.getItem("EmergencyAccessEnabled")) {
                if (sessionStorage.getItem("EnableEmergencyAccess"))
                    type = 'Emergencyuser'
            }

            this._documentService.GetComponentRolePermissions(roleid, type, userid).subscribe(result => {
                result = result.filter(i => i.permissions != "");
                sessionStorage.setItem("UserPermComp", JSON.stringify(result));
            });
        }

    }
    getPermissionsByComponentId(component_RoleMasterEnum: Component_RoleMasterEnum): string {
        if (configuration.ISONCEnabled == true) {
            if (sessionStorage.getItem("EmergencyAccessEnabled") && sessionStorage.getItem("EnableEmergencyAccess")) {
                return "R~W~D"
            }
            const componentid = component_RoleMasterEnum;
            if (sessionStorage.getItem("UserPermComp")) {
                const UserPermComp = JSON.parse(sessionStorage.getItem("UserPermComp"));
                const retval = UserPermComp.find(i => i.componentId == componentid);
                if (retval && retval.permissions)
                    //    UserPermComp.filter(i => i.componentId == componentid)[0].permissions;
                    return retval.permissions;
                else
                    return "";
            }
        }
        else {
            return "R~W~D"
        }

        return "";
    }



}


